import axios from 'axios';

//initial state
const state = {
    permissions: []
}

//getters
const getters = {

}

//actions
const actions = {
    async getPermissions( {commit} ) {
      await axios
        .get('/users/permissions/all')
        .then( response => (commit('setPermissions', response.data)));
    }
}

//mutations 
const mutations = {
    setPermissions (state, permissions) {
      state.permissions = permissions;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}